export default __webpack_public_path__ + "static/media/logo.9a4f06a1.svg";